module.exports = __webpack_public_path__ + "static/media/cart-icon-desktop.1552c357.svg";